import { render } from "./indexRealtorsReserves.vue?vue&type=template&id=56ef80b9&scoped=true"
import script from "./indexRealtorsReserves.vue?vue&type=script&lang=js"
export * from "./indexRealtorsReserves.vue?vue&type=script&lang=js"

import "./indexRealtorsReserves.vue?vue&type=style&index=0&id=56ef80b9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ef80b9"]])

export default __exports__